/**
 * Viavini — carrinho lateral (port de Magento_Catalog/js/vv-sidecart.js da produção).
 *
 * Abre ao ADICIONAR um item (evento shopify:cart:lines-update do formulário de compra, depois que
 * o carrinho já foi atualizado) e ao clicar no ícone do carrinho do cabeçalho; fecha no X, no fundo
 * escuro, em "Continuar comprando" e no Esc. Quantidade (− N +, mínimo 1; remover é pela lixeira)
 * usa /cart/change.js pela chave da linha, e a resposta já traz a seção vv-sidecart renderizada de
 * novo (Section Rendering API): itens, totais e descontos vêm sempre do servidor.
 *
 * Markup: sections/vv-sidecart.liquid (renderizada em layout/theme.liquid).
 */
(function () {
  'use strict';

  var SECTION = 'vv-sidecart';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var drawer, overlay, lastFocus;
  var updating = false;

  function open() {
    if (!drawer || drawer.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    drawer.inert = false;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('vv-sidecart-open');
    var closeBtn = drawer.querySelector('.vv-sidecart-close');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.inert = true;
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('vv-sidecart-open');
    if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  /* Contador do cabeçalho (vv-magento.js cuida do markup) */
  function notifyCount(count) {
    document.dispatchEvent(new CustomEvent('vv:cart:count', { detail: { count: count } }));
  }

  /**
   * Troca só o conteúdo (contador, itens e rodapé): o painel e o fundo continuam no DOM, então a
   * gaveta aberta não pisca nem perde a transição.
   */
  function apply(html) {
    if (!html || !drawer) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-role="vv-sidecart"]');
    if (!fresh) return;
    ['[data-role="vv-sidecart-count"]', '[data-role="vv-sidecart-items"]', '.vv-sidecart-foot'].forEach(function (sel) {
      var current = drawer.querySelector(sel);
      var next = fresh.querySelector(sel);
      if (current && next) current.innerHTML = next.innerHTML;
    });
    drawer.classList.toggle('vv-sidecart--empty', fresh.classList.contains('vv-sidecart--empty'));
    var count = fresh.querySelector('[data-role="vv-sidecart-count"]');
    if (count) notifyCount(parseInt(count.textContent, 10) || 0);
  }

  function refresh() {
    return fetch(root + '?section_id=' + SECTION, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(apply);
  }

  function setBusy(busy) {
    drawer.classList.toggle('vv-sidecart--busy', busy);
  }

  function change(key, quantity) {
    if (updating || !key) return;
    updating = true;
    setBusy(true);

    /* Trava de segurança: se a resposta não vier, libera o − / + / lixeira depois de 7 s */
    var safety = setTimeout(done, 7000);
    function done() {
      clearTimeout(safety);
      updating = false;
      setBusy(false);
    }

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data || {} }; });
      })
      .then(function (res) {
        /* Recusado (ex.: acima do estoque): o novo render volta o número ao estado real */
        if (!res.ok) {
          if (window.console) console.warn('[vv-sidecart] ' + (res.data.description || res.data.message || ''));
          return refresh();
        }
        if (res.data.sections && res.data.sections[SECTION]) return apply(res.data.sections[SECTION]);
        return refresh();
      })
      .catch(refresh)
      .then(done, done);
  }

  function init() {
    drawer = document.querySelector('[data-role="vv-sidecart"]');
    if (!drawer) return;
    overlay = document.querySelector('[data-role="vv-sidecart-overlay"]');
    drawer.inert = !drawer.classList.contains('is-open');

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;

      /* Ícone do carrinho do cabeçalho: abre a gaveta em vez de ir para /cart */
      if (t.closest('[data-vv-cart-toggle], [data-role="vv-sidecart-trigger"]')) {
        e.preventDefault();
        open();
        return;
      }

      if (t.closest('[data-role="vv-sidecart-close"]') || t === overlay) {
        e.preventDefault();
        close();
        return;
      }

      var item = t.closest('.vv-sidecart-item');
      if (!item || !drawer.contains(item)) return;
      var key = item.getAttribute('data-item-id');
      var qty = parseInt(item.getAttribute('data-qty'), 10) || 1;

      if (t.closest('[data-role="vv-qty-inc"]')) {
        e.preventDefault();
        change(key, qty + 1);
      } else if (t.closest('[data-role="vv-qty-dec"]')) {
        e.preventDefault();
        if (qty > 1) change(key, qty - 1);
      } else if (t.closest('[data-role="vv-remove"]')) {
        e.preventDefault();
        change(key, 0);
      }
    });

    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Abrir de qualquer lugar sem navegar (mesmo evento da produção) */
    document.addEventListener('vv:sidecart:open', open);

    /* Item adicionado (formulário de compra do Horizon): atualiza e abre; outras mudanças só atualizam */
    document.addEventListener('shopify:cart:lines-update', function (e) {
      var promise = e.promise && typeof e.promise.then === 'function' ? e.promise : Promise.resolve(null);
      promise
        .then(function (result) {
          if (result && result.detail && result.detail.didError) return;
          return refresh().then(function () {
            if (e.action === 'add') open();
          });
        })
        .catch(function () {});
    });

    /* Volta pelo histórico (bfcache): o carrinho pode ter mudado em outra aba */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
